
import Vue, { VNode } from 'vue'
import { mapGetters } from 'vuex'
import PaidLabelWrapper from './PaidLabelWrapper.vue'

import type { TPaidLabelTheme, TPaidConditionRules } from '@/models/paidLabel'
import type { ScriptUnit } from '@/models/scripts'

interface Computed {
  getScriptsList: ScriptUnit[]
  getTotalActiveUsers: number
  proCondition: boolean
  isProCompany: boolean
  isShowProWrapper: boolean
}

interface Props {
  rule?: TPaidConditionRules
  theme?: TPaidLabelTheme
  component?: string
  condition: boolean
}

export default Vue.extend<{}, {}, Computed, Props>({
  props: {
    rule: {
      default: () => undefined,
    },
    theme: {
      required: false,
    },
    component: {
      default: () => ''
    },
    condition: {
      default: () => true,
    },
  },
  components: {
    PaidLabelWrapper,
  },
  computed: {
    ...mapGetters(['getScriptsList', 'getTotalActiveUsers']),
    isProCompany(): boolean {
      return this.$store.getters.getCompanyIsPro
    },
    proCondition(): boolean {
      switch (this.rule) {
        case 'create-script':
          return this.getScriptsList.length > 1
        case 'add-user':
          return this.getTotalActiveUsers > 2
        default:
          return true
      }
    },
    isShowProWrapper(): boolean {
      return !this.isProCompany && this.proCondition && this.condition
    },
  },
  render(createElement) {
    const nodes: VNode[] = this.$slots.default ?? []

    if (this.isShowProWrapper) {
      return createElement('PaidLabelWrapper', {
        props: {
          theme: this.theme,
          component: this.component,
        },
      }, nodes)
    }

    if (this.component) {
      return createElement(this.component, nodes)
    }

    return nodes.length > 1 ? createElement('div', nodes) : nodes[0]
  },
})
